(ns frontend.test.search.view
  (:require [common.localization :as loc]
            [frontend.test.search.event :as event]
            [frontend.test.search.sub :as sub]
            [re-frame.core :as rf]
            [ui.components.search.view :as search]))

(defn view
  []
  (let [value @(rf/subscribe [::sub/search-query])
        hits @(rf/subscribe [::sub/hits])]
    [:div
     {:class "p-4 w-[1024px] mx-auto"}
     [search/view
      {:value          value
       :matching-items hits
       :placeholder    (loc/tr :search-placeholder)
       :render-item-fn (fn [v]
                         [:div
                          {:class ""}
                          (:label v)])
       :on-change       (fn [v]
                         (rf/dispatch [::event/search-by v]))
       :on-select      (fn [v]
                         (rf/dispatch [::event/select-hit v]))}]]))
